import React from 'react';
import Excel from "../../assets/images/excel.png";
import SilverButton from "./SilverButton";
import LoadingComponent from "../../assets/LoadingComponent";


const ExcelButton = ({ onClick, alt = 'Export', height = 40, width = 40 , children, variant = 'default', disabled = false, loading = false}) => {
    return (
        <SilverButton
            width={width}
            height={height}
            onClick={onClick}
            variant={variant}
            disabled={loading || disabled}
        >
            {
                loading ?
                    <LoadingComponent size={20} />
                        :
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent',height: '100%',width: '100%' }}>
                        <img
                            src={Excel}
                            alt={alt}
                            style={{
                                height: '24px',
                                width: "auto"
                            }}
                        />

                        {children}
                    </div>
            }

        </SilverButton>
    );
};

export default ExcelButton;



// WEBPACK FOOTER //
// ./src/components-new/buttons/ExcelButton.jsx